// ADD LOADING ATTRIBUTE POLYFILL
import { scrollToTarget } from "./utils/scrollToTarget";

require('loading-attribute-polyfill');
import CraftVars from './services/craftVars';
import breakpoints from './utils/breakpoints'

//import IframeYoutube from './components/IframeYoutube/IframeYoutube'
//customElements.define('iframe-youtube', IframeYoutube)

//import IframeVimeo from './components/IframeVimeo/IframeVimeo'
//customElements.define('iframe-vimeo', IframeVimeo)

import ToggleElement from './utils/ToggleElement.js'
import PortraitBioToggler from './utils/PortraitBioToggler.js'
import { maskedText } from './components/MaskedText/maskedText.js';
import Spinner from './components/Spinner/Spinner.js';
import { ScrollTrigger } from './components/ScrollTrigger/ScrollTrigger.js';
import initMenuMobile from './components/Menu/MenuMobile'
import initMegaMenu from './components/Menu/MegaMenu'
import ScrollShadow from './components/ScrollShadow/ScrollShadow'
import AnchorLink from './components/AnchorLink/AnchorLink.js'
// TODO example of header scroll behaviour
import { HeaderScroll } from './components/HeaderScroll/HeaderScroll';
import { ClampedText } from "./components/ClampedText/ClampedText"
import { LightGallery } from './components/LightGallery/LightGallery.js';
import UploadHelper from './components/UploadHelper/UploadHelper.js'



const defaultCovers = [...document.querySelectorAll("[data-lightbox-default-cover]")]
defaultCovers.forEach(cover => {
    cover.addEventListener('load', (el) => {      
        const image = el.target
        if (image.naturalHeight === 90) {
            const defaultCover = image.dataset.lightboxDefaultCover
            image.src = defaultCover
            image.closest("[data-poster]").dataset.poster = defaultCover
        }
    })
})


window.addEventListener('DOMContentLoaded', () => {
  ClampedText()
  HeaderScroll()

  initMenuMobile({ menuBreakpoint: breakpoints.large })
  initMegaMenu({ largeWidth: breakpoints.large })


  LightGallery()

  const scrollShadowElements = [...document.querySelectorAll('[data-scroll-shadow]')];
  for (let scrollShadowElement of scrollShadowElements) {
    ScrollShadow(scrollShadowElement, true)
  }

  const spinnerButtons = [...document.querySelectorAll('[data-spinner-decrease],[data-spinner-increase]')]
  for (let spinnerButton of spinnerButtons) {
    new Spinner(spinnerButton)
  }

  const anchorLinks = [...document.querySelectorAll('[data-anchor-link]')]
  for (let anchorLink of anchorLinks) {
    new AnchorLink(anchorLink)
  }

  const toScrollTrigger = [...document.querySelectorAll('[data-scroll-trigger]')];
  if (toScrollTrigger.length) {
    ScrollTrigger(toScrollTrigger)
  }

  const uploadHelperElements = [...document.querySelectorAll('[data-upload-helper]')];
  for (let uploadHelperElement of uploadHelperElements) {
    new UploadHelper(uploadHelperElement)
  }

  /*  const maskedLines = [...document.querySelectorAll('.masked-line')];
    if (maskedLines.length) {
      maskedText(maskedLines)
    }*/

  const maskedGroup = [...document.querySelectorAll('[data-scroll-trigger="unmask"]')];
  if (maskedGroup.length) {
    maskedText(maskedGroup)
  }

  const ToggleTriggers = [...document.querySelectorAll('[data-toggle-trigger]')]
  for (let trigger of ToggleTriggers) {
    new ToggleElement(trigger)
  }

  const portraitBioToggler = [...document.querySelectorAll('[data-portrait-bio-toggle]')]
  if (portraitBioToggler) {
    new PortraitBioToggler(portraitBioToggler)
  }


})


